import React from 'react';

const Calendar = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4.25" y="3.75" width="16.5" height="16.5" rx=".563" stroke="#000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M17 2.25v3M8 2.25v3M4.25 8.25h16.5" stroke="#000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      <rect x="7.25" y="11.25" width="3.75" height="3.75" rx=".563" fill="#000" />
    </svg>

  );
};

export default Calendar;
